import { IconPhone } from '@pentabd/icons';
import { Text, Button } from '@pentabd/ui';
import { CenterWiseResultsType } from '@type/centerWiseResults';
import { Link } from 'react-router-dom';

export const PresidingOfficerInfo = ({
  row,
}: {
  row?: CenterWiseResultsType;
}) => {
  return (
    <>
      <Text className="text-nowrap mb-5" component="p">
        {row?.presiding_officer_name || ''}
      </Text>
      <Text className="text-nowrap" component="p">
        <Link to={`tel:${row?.presiding_officer_phone}`}>
          {row?.presiding_officer_phone && (
            <Button fill="outline" type="dark" className="p-3">
              <IconPhone fill="dark" size="16" />
            </Button>
          )}
        </Link>{' '}
        {row?.presiding_officer_phone || ''}
      </Text>
    </>
  );
};
